import { defineMessages } from 'react-intl';

const translations = {
  mappingError: {
    id: 'batchMappingForm.mappingError',
    defaultMessage: 'The following columns are required: {columns}',
    description: 'Error message column mapping for missing required fields',
  },
};

export default defineMessages(translations);
